(function () {
  'use strict';

  var Utils = window.TDCUtils;
  var root = document.documentElement;

  var shippingThreshold = (window.theme && window.theme.shippingThreshold) || 15000;
  var isUpdating = false;

  function setCartLoading(on) {
    var itemsEl = getDrawerItemsEl();
    if (itemsEl) itemsEl.classList.toggle('is-loading', !!on);
    // Also apply to cart page list for cart-page actions
    var cpList = document.querySelector('.cart-page .cart-items-wrap, .cart-page ul.cart-items, .cart-page .line-items');
    if (cpList) cpList.classList.toggle('is-loading', !!on);
  }

  function getDrawer() {
    return document.getElementById('cart');
  }

  function getDrawerItemsEl() {
    var d = getDrawer();
    return d ? d.querySelector('#cart-items') : document.getElementById('cart-items');
  }

  function getDrawerSubtotalEl() {
    var d = getDrawer();
    return d ? d.querySelector('[data-drawer-subtotal], #subtotal') : document.getElementById('subtotal');
  }

  function getDrawerShipBox() {
    var d = getDrawer();
    return d ? d.querySelector('#ship') : document.getElementById('ship');
  }

  function getDrawerShipTrack() {
    var d = getDrawer();
    return d ? d.querySelector('#ship-track') : document.getElementById('ship-track');
  }

  function getDrawerShipFill() {
    var d = getDrawer();
    return d ? d.querySelector('#ship-fill') : document.getElementById('ship-fill');
  }

  function getDrawerEmpty() {
    var d = getDrawer();
    return d ? d.querySelector('#cart-empty') : document.getElementById('cart-empty');
  }

  function getDrawerFoot() {
    var d = getDrawer();
    return d ? d.querySelector('#cart-foot') : document.getElementById('cart-foot');
  }

  function getDrawerUpsell() {
    var d = getDrawer();
    return d ? d.querySelector('#upsell') : document.getElementById('upsell');
  }

  function getDrawerUpsellList() {
    var d = getDrawer();
    return d ? d.querySelector('#upsell-list') : document.getElementById('upsell-list');
  }

  function getDrawerGift() {
    var d = getDrawer();
    return d ? d.querySelector('#gift') : document.getElementById('gift');
  }

  function updateCounts(count, bump) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (bump && el.classList.contains('count')) {
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      }
    });
  }

  function updateShippingProgress(cart) {
    var total = (cart && cart.total_price) || 0;
    var pct = Math.min(100, Math.round((total / shippingThreshold) * 100));

    // Update Drawer Shipping
    var dFill = getDrawerShipFill();
    var dTrack = getDrawerShipTrack();
    var dBox = getDrawerShipBox();
    if (dFill) dFill.style.width = pct + '%';
    if (dTrack) {
      if (total >= shippingThreshold) {
        dTrack.classList.add('done');
        if (dBox) {
          var p = dBox.querySelector('p');
          if (p) p.textContent = 'You qualify for free shipping!';
        }
      } else {
        dTrack.classList.remove('done');
        if (dBox) {
          var msg = dBox.getAttribute('data-default-msg') || 'Shipping is calculated at checkout. Processing time is listed on each product page.';
          var p2 = dBox.querySelector('p');
          if (p2) p2.textContent = msg;
        }
      }
    }

    // Update Cart Page Shipping
    var cpFill = document.getElementById('cart-page-ship-fill');
    var cpTrack = document.getElementById('cart-page-ship-track');
    var cpMsg = document.getElementById('cart-page-ship-msg');
    if (cpFill) cpFill.style.width = pct + '%';
    if (cpTrack) {
      if (total >= shippingThreshold) {
        cpTrack.classList.add('done');
        if (cpMsg) cpMsg.textContent = 'You qualify for free shipping!';
      } else {
        cpTrack.classList.remove('done');
        if (cpMsg) {
          var cpDefaultMsg = cpMsg.getAttribute('data-default-msg') || 'Shipping is calculated at checkout. Processing time is listed on each product page.';
          cpMsg.textContent = cpDefaultMsg;
        }
      }
    }
  }

  function renderCartPageDOM(cart) {
    var cartPage = document.querySelector('.cart-page');
    var cartEmpty = document.getElementById('cart-page-empty') || document.querySelector('.cart-empty-state');
    var count = cart.item_count || 0;

    if (count === 0) {
      if (cartPage) cartPage.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = '';
      return;
    }

    if (cartPage) cartPage.style.display = '';
    if (cartEmpty) cartEmpty.style.display = 'none';

    // Update subtotal & estimated total on cart page
    var cpSubtotal = document.getElementById('cart-page-subtotal') || document.querySelector('[data-cart-subtotal]');
    if (cpSubtotal) cpSubtotal.textContent = Utils.formatMoney(cart.total_price);

    var cpTotal = document.getElementById('cart-page-total') || document.querySelector('[data-cart-total]');
    if (cpTotal) cpTotal.textContent = Utils.formatMoney(cart.total_price);

    // Calculate total savings
    var totalSavings = 0;
    if (cart.items) {
      cart.items.forEach(function (item) {
        var compareUnit = (window._variantComparePrices && (window._variantComparePrices[item.id] || window._variantComparePrices[item.variant_id])) || 0;
        if (compareUnit > item.price) {
          totalSavings += (compareUnit - item.price) * item.quantity;
        } else if (item.original_line_price > item.final_line_price) {
          totalSavings += (item.original_line_price - item.final_line_price);
        }
      });
    }

    var cpSavingsRow = document.getElementById('cart-page-savings-row');
    var cpSavingsVal = document.getElementById('cart-page-savings-value');
    if (cpSavingsRow) {
      if (totalSavings > 0) {
        cpSavingsRow.style.display = '';
        if (cpSavingsVal) cpSavingsVal.textContent = 'Save ' + Utils.formatMoney(totalSavings);
      } else {
        cpSavingsRow.style.display = 'none';
      }
    }

    // Update cart page line items
    if (cartPage && cart.items) {
      var lineItems = cartPage.querySelectorAll('.line-item[data-key]');
      lineItems.forEach(function (row) {
        var key = row.getAttribute('data-key');
        var cartItem = cart.items.find(function (i) { return String(i.key) === String(key); });
        if (!cartItem) {
          row.remove();
        } else {
          var input = row.querySelector('.qty-input, input[name="quantity"]');
          if (input) input.value = cartItem.quantity;

          var btnMinus = row.querySelector('.qty button[value]:first-of-type');
          if (btnMinus) btnMinus.setAttribute('value', Math.max(0, cartItem.quantity - 1));

          var btnPlus = row.querySelector('.qty button[value]:last-of-type');
          if (btnPlus) btnPlus.setAttribute('value', cartItem.quantity + 1);

          var priceEl = row.querySelector('.li-price');
          if (priceEl) {
            var finalLinePrice = cartItem.final_line_price != null ? cartItem.final_line_price : (cartItem.line_price != null ? cartItem.line_price : cartItem.price * cartItem.quantity);
            var linePrice = Utils.formatMoney(finalLinePrice);
            var compareUnit = (window._variantComparePrices && (window._variantComparePrices[cartItem.id] || window._variantComparePrices[cartItem.variant_id])) || 0;
            var origLinePrice = compareUnit > 0 ? (compareUnit * cartItem.quantity) : (cartItem.original_line_price > finalLinePrice ? cartItem.original_line_price : 0);
            var priceDisplay = linePrice;
            if (origLinePrice > finalLinePrice) {
              var pct = Math.round(((origLinePrice - finalLinePrice) / origLinePrice) * 100);
              priceDisplay += ' <s class="compare-price">' + Utils.formatMoney(origLinePrice) + '</s>';
              if (pct > 0) {
                priceDisplay += ' <span class="price-save">Save ' + pct + '%</span>';
              }
            }
            priceEl.innerHTML = priceDisplay;
          }
        }
      });
    }
  }

  function buildLineItemHTML(item, idx, itemImg, priceDisplay, invQty, invManaged, invPolicy) {
    var title = item.product_title || item.title;
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return '<div class="line-item" data-key="' + Utils.esc(item.key) + '" data-id="' + item.id + '" data-line="' + (idx + 1) + '" data-inv-qty="' + invQty + '" data-inv-managed="' + Utils.esc(invManaged) + '" data-inv-policy="' + Utils.esc(invPolicy) + '">' +
      '<div class="thumb product">' + (itemImg ? '<img src="' + Utils.esc(itemImg) + '" alt="' + Utils.esc(title) + '" width="80" height="100" loading="lazy">' : '') + '</div>' +
      '<div>' +
      '<div class="li-top">' +
      '<span class="li-name">' + Utils.esc(title) + '</span>' +
      '<span class="li-price">' + priceDisplay + '</span>' +
      '</div>' +
      (variantTitle ? '<div class="li-meta">' + Utils.esc(variantTitle) + '</div>' : '') +
      '<div class="li-actions">' +
      '<div class="qty" role="group" aria-label="Quantity for ' + Utils.esc(title) + '">' +
      '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
      '<output aria-live="polite">' + item.quantity + '</output>' +
      '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button class="text-btn" type="button" data-remove-item>' + (window.theme && window.theme.translations && window.theme.translations.cart_remove ? window.theme.translations.cart_remove : 'Remove') + '</button>' +
      '</div>' +
      '<div class="li-inv-error" hidden></div>' +
      '</div>' +
      '</div>';
  }

  function syncDrawerLineItems(itemsEl, cartItems) {
    var currentDomRows = Array.prototype.slice.call(itemsEl.querySelectorAll('.line-item'));
    var existingMap = {};
    currentDomRows.forEach(function (row) {
      var k = row.getAttribute('data-key');
      if (k) existingMap[k] = row;
    });

    var newKeyMap = {};

    cartItems.forEach(function (item, idx) {
      var keyStr = String(item.key);
      newKeyMap[keyStr] = true;

      var imgRaw = item.featured_image ? (item.featured_image.url || item.featured_image) : (item.image || '');
      var itemImg = imgRaw ? Utils.resizeImageUrl(String(imgRaw), 200) : '';
      var finalLinePrice = item.final_line_price != null ? item.final_line_price : (item.line_price != null ? item.line_price : item.price * item.quantity);
      var linePrice = Utils.formatMoney(finalLinePrice);
      var compareUnit = (window._variantComparePrices && (window._variantComparePrices[item.id] || window._variantComparePrices[item.variant_id])) || 0;
      var origLinePrice = compareUnit > 0 ? (compareUnit * item.quantity) : (item.original_line_price > finalLinePrice ? item.original_line_price : 0);
      var priceDisplay = linePrice;
      if (origLinePrice > finalLinePrice) {
        var pct = Math.round(((origLinePrice - finalLinePrice) / origLinePrice) * 100);
        priceDisplay += ' <s class="compare-price">' + Utils.formatMoney(origLinePrice) + '</s>';
        if (pct > 0) {
          priceDisplay += ' <span class="price-save">Save ' + pct + '%</span>';
        }
      }

      var invInfo = window._variantInventory && (window._variantInventory[item.id] || window._variantInventory[item.variant_id]);
      var invQty = -1;
      var invManaged = '';
      var invPolicy = '';
      if (invInfo) {
        invManaged = invInfo.management || '';
        invPolicy = invInfo.policy || '';
        if (invManaged && invPolicy !== 'continue' && invInfo.qty != null) {
          invQty = invInfo.qty;
        }
      } else if (item.inventory_management && item.inventory_policy !== 'continue' && item.inventory_quantity != null) {
        invQty = item.inventory_quantity;
        invManaged = item.inventory_management;
        invPolicy = item.inventory_policy;
      }

      var existingRow = existingMap[keyStr];
      if (existingRow) {
        // If element is in the middle of being removed, let its animation finish
        if (existingRow.classList.contains('is-removing')) return;

        // IN-PLACE UPDATE: Never destroy or rebuild DOM nodes!
        existingRow.setAttribute('data-line', idx + 1);
        existingRow.setAttribute('data-inv-qty', invQty);
        existingRow.setAttribute('data-inv-managed', invManaged);
        existingRow.setAttribute('data-inv-policy', invPolicy);

        var isQueued = window.TDCCartQueue && window.TDCCartQueue.isPending(item.key);
        if (!isQueued) {
          var out = existingRow.querySelector('output');
          if (out && out.textContent !== String(item.quantity)) {
            out.textContent = item.quantity;
          }
          existingRow._targetQty = item.quantity;
        }

        var priceEl = existingRow.querySelector('.li-price');
        if (priceEl && priceEl.innerHTML !== priceDisplay) {
          priceEl.innerHTML = priceDisplay;
        }

        var expectedChild = itemsEl.children[idx];
        if (expectedChild && expectedChild !== existingRow) {
          itemsEl.insertBefore(existingRow, expectedChild);
        } else if (!expectedChild) {
          itemsEl.appendChild(existingRow);
        }
      } else {
        // New item: create element and append/insert smoothly
        var temp = document.createElement('div');
        temp.innerHTML = buildLineItemHTML(item, idx, itemImg, priceDisplay, invQty, invManaged, invPolicy);
        var newRow = temp.firstElementChild;
        if (newRow) {
          newRow.classList.add('is-new-item');
          if (itemsEl.children[idx]) {
            itemsEl.insertBefore(newRow, itemsEl.children[idx]);
          } else {
            itemsEl.appendChild(newRow);
          }
          requestAnimationFrame(function () {
            newRow.classList.add('is-visible');
          });
        }
      }
    });

    // Remove rows that are no longer in cart
    currentDomRows.forEach(function (row) {
      var k = row.getAttribute('data-key');
      if (k && !newKeyMap[k]) {
        if (!row.classList.contains('is-removing')) {
          row.remove();
        }
      }
    });
  }

  function renderCartDOM(cart) {
    var itemsEl = getDrawerItemsEl();
    var emptyCart = getDrawerEmpty();
    var foot = getDrawerFoot();
    var upsell = getDrawerUpsell();
    var gift = getDrawerGift();
    var shipBox = getDrawerShipBox();
    var subtotalEl = getDrawerSubtotalEl();
    var upsellList = getDrawerUpsellList();
    var shipTrack = getDrawerShipTrack();
    var shipFill = getDrawerShipFill();

    var count = cart.item_count || 0;
    var has = count > 0 && cart.items && cart.items.length > 0;

    if (emptyCart) emptyCart.hidden = has;
    if (foot) { foot.style.display = ''; foot.hidden = !has; }
    if (upsell) upsell.hidden = !has;
    if (gift) gift.hidden = !has;
    if (shipBox) shipBox.hidden = !has;

    updateCounts(count, false);
    flattenExpressCheckout();

    if (!has) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (subtotalEl) subtotalEl.textContent = '$0';
      if (upsellList) upsellList.innerHTML = '';
      if (shipTrack) shipTrack.classList.remove('done');
      if (shipFill) shipFill.style.width = '0%';
      renderCartPageDOM(cart);
      syncCardButtonLimits(cart);
      return;
    }

    if (itemsEl) {
      syncDrawerLineItems(itemsEl, cart.items);
    }

    if (subtotalEl) subtotalEl.textContent = Utils.formatMoney(cart.total_price);
    updateShippingProgress(cart);
    renderCartPageDOM(cart);
    syncCardButtonLimits(cart);

    if (upsellList && cart.items.length > 0) {
      var firstProductId = cart.items[0].product_id;
      if (upsellList._loadedProductId !== firstProductId) {
        upsellList._loadedProductId = firstProductId;
        fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=2', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
          .then(function (data) {
            var recs = data.products || [];
            if (!recs.length) { if (upsellList) upsellList.innerHTML = ''; return; }
            var cartIds = cart.items.map(function (i) { return i.product_id; });
            var filtered = recs.filter(function (r) { return cartIds.indexOf(r.id) < 0; }).slice(0, 2);
            upsellList.innerHTML = filtered.map(function (p) {
              var img = p.featured_image ? Utils.resizeImageUrl(p.featured_image, 200) : '';
              var variant = p.variants && p.variants[0] ? p.variants[0] : null;
              var price = variant ? Utils.formatMoney(variant.price) : '';
              return '<div class="upsell-item">' +
                '<div class="thumb">' + (img ? '<img src="' + Utils.esc(img) + '" alt="' + Utils.esc(p.title) + '" width="60" height="75">' : '') + '</div>' +
                '<div><strong>' + Utils.esc(p.title) + '</strong><span>' + price + '</span></div>' +
                '<button class="btn-sm" type="button" data-upsell-id="' + (variant ? variant.id : '') + '" aria-label="Add ' + Utils.esc(p.title) + '">Add</button>' +
                '</div>';
            }).join('');
          })
          .catch(function () { if (upsellList) upsellList.innerHTML = ''; });
      }
    }
  }

  function fetchCartAndRender() {
    setCartLoading(true);
    return fetch('/cart.js?_=' + Date.now(), {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart API error');
        return res.json();
      })
      .then(function (cart) {
        window.TDCCart = window.TDCCart || {};
        window.TDCCart.currentCart = cart;
        // After cart fully refreshed, clear optimistic pending quantities
        // (The real cart now has authoritative qty — no more guessing needed)
        if (window.TDCCartGuard) window.TDCCartGuard.reset();
        renderCartDOM(cart);
        setCartLoading(false);
        // Notify other parts of the page (PDP, collection) that cart has changed
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        } catch (e) {}
        return cart;
      })
      .catch(function (err) {
        setCartLoading(false);
        console.warn('[TDC Cart] Could not load cart:', err.message);
        var emptyCart = getDrawerEmpty();
        var foot = getDrawerFoot();
        if (emptyCart) emptyCart.hidden = false;
        if (foot) { foot.style.display = ''; foot.hidden = true; }
      });
  }

  function addToCart(variantId, qty, onSuccess, onError) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (errJson) {
            var msg = errJson.description || errJson.message || 'Add to cart failed';
            var err = new Error(msg);
            err.data = errJson;
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        return fetchCartAndRender();
      })
      .then(function () {
        // After cart confirmed, clear the optimistic reservation
        if (window.TDCCartGuard) window.TDCCartGuard.confirm(variantId, qty);
        if (window.TDCOverlay && window.TDCOverlay.open) {
          window.TDCOverlay.open('cart');
        }
        var bagIcon = document.querySelector('[data-open="cart"]');
        if (bagIcon) {
          bagIcon.classList.remove('bag-pulse');
          void bagIcon.offsetWidth;
          bagIcon.classList.add('bag-pulse');
        }
        if (onSuccess) onSuccess();
      })
      .catch(function (err) {
        // Release optimistic reservation on failure
        if (window.TDCCartGuard) window.TDCCartGuard.release(variantId, qty);
        setCartLoading(false);
        console.warn('[TDC Cart] addToCart error:', err.message);
        if (window.TDCToast && window.TDCToast.warning) {
          window.TDCToast.warning(err.message, 'Quantity limit reached');
        }
        if (onError) onError(err);
      });
  }

  function removeItem(row, key, line) {
    if (!row || row.classList.contains('is-removing')) return;

    row.classList.add('is-removing');
    row.style.pointerEvents = 'none';

    // 1. Explicitly capture starting dimensions for the browser transition
    var startHeight = row.offsetHeight;
    row.style.boxSizing = 'border-box';
    row.style.height = startHeight + 'px';
    row.style.maxHeight = startHeight + 'px';
    row.style.overflow = 'hidden';

    // 2. Force reflow so browser registers the starting height
    void row.offsetHeight;

    // 3. Trigger collapse in animation frame
    requestAnimationFrame(function () {
      row.style.opacity = '0';
      row.style.transform = 'translateY(-8px)';
      row.style.height = '0';
      row.style.maxHeight = '0';
      row.style.paddingTop = '0';
      row.style.paddingBottom = '0';
      row.style.paddingBlock = '0';
      row.style.marginTop = '0';
      row.style.marginBottom = '0';
      row.style.borderBottomWidth = '0';
      row.style.borderBottomColor = 'transparent';
    });

    var payload = {};
    if (key) {
      payload.id = String(key);
      payload.quantity = 0;
    } else if (line) {
      payload.line = parseInt(line, 10);
      payload.quantity = 0;
    }

    var removeTimer = setTimeout(function () {
      if (row && row.parentNode) {
        row.remove();
      }
    }, 360);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart remove failed');
        return res.json();
      })
      .then(function (cart) {
        window.TDCCart = window.TDCCart || {};
        window.TDCCart.currentCart = cart;
        if (window.TDCCartGuard) window.TDCCartGuard.reset();

        var count = cart.item_count || 0;
        if (count === 0) {
          // If no items remain, wait for the removing item's collapse animation before showing empty state
          setTimeout(function () {
            clearTimeout(removeTimer);
            if (row && row.parentNode) row.remove();
            renderCartDOM(cart);
            updateCounts(0, false);
          }, 320);
        } else {
          renderCartDOM(cart);
          updateCounts(count, true);
        }

        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        } catch (e) {}
      })
      .catch(function (err) {
        console.warn('[TDC Cart] removeItem error:', err.message);
        clearTimeout(removeTimer);
        row.classList.remove('is-removing');
        row.style.height = '';
        row.style.maxHeight = '';
        row.style.opacity = '';
        row.style.transform = '';
        row.style.overflow = '';
        row.style.paddingTop = '';
        row.style.paddingBottom = '';
        row.style.paddingBlock = '';
        row.style.marginTop = '';
        row.style.marginBottom = '';
        row.style.borderBottomWidth = '';
        row.style.borderBottomColor = '';
        row.style.pointerEvents = '';
        if (window.TDCToast && window.TDCToast.warning) {
          window.TDCToast.warning(err.message, 'Could not remove item');
        }
      });
  }

  var TDCCartQueue = {
    inFlight: {},      // key -> bool
    pending: {},       // key -> targetQty
    timers: {},        // key -> timerId

    isPending: function (key) {
      if (!key) return false;
      var k = String(key);
      return !!(this.inFlight[k] || this.pending[k] != null || this.timers[k]);
    },

    setTarget: function (key, line, targetQty, row) {
      var self = this;
      var k = String(key || line);
      self.pending[k] = targetQty;

      clearTimeout(self.timers[k]);
      self.timers[k] = setTimeout(function () {
        delete self.timers[k];
        self.process(key, line, row);
      }, 200);
    },

    process: function (key, line, row) {
      var self = this;
      var k = String(key || line);

      // If a request is already in-flight for this item, wait until it finishes
      if (self.inFlight[k]) return;

      var target = self.pending[k];
      if (target == null) return;

      if (target === 0) {
        delete self.pending[k];
        removeItem(row, key, line);
        return;
      }

      self.inFlight[k] = true;
      var qtyToSend = target;

      var payload = {};
      if (key) {
        payload.id = String(key);
        payload.quantity = qtyToSend;
      } else if (line) {
        payload.line = parseInt(line, 10);
        payload.quantity = qtyToSend;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errJson) {
              var errMsg = errJson.description || errJson.message || 'Cart change failed';
              var err = new Error(errMsg);
              err.data = errJson;
              throw err;
            });
          }
          return res.json();
        })
        .then(function (cart) {
          self.inFlight[k] = false;
          window.TDCCart = window.TDCCart || {};
          window.TDCCart.currentCart = cart;
          if (window.TDCCartGuard) window.TDCCartGuard.reset();

          // Check if user clicked MORE times while this request was in flight
          if (self.pending[k] != null && self.pending[k] !== qtyToSend) {
            self.process(key, line, row);
            return;
          }

          // All clicks finished processing for this item!
          delete self.pending[k];

          // Check if Shopify returned a capped quantity due to inventory limit
          var updatedItem = cart.items && cart.items.find(function (i) {
            return String(i.key) === String(key) || String(i.id) === String(key);
          });
          if (updatedItem && row) {
            row._targetQty = updatedItem.quantity;
            var out = row.querySelector('output');
            if (out) out.textContent = updatedItem.quantity;
            if (updatedItem.quantity < qtyToSend) {
              var warnMsg = 'Only ' + updatedItem.quantity + ' available.';
              if (window.TDCToast && window.TDCToast.warning) {
                window.TDCToast.warning(warnMsg, 'Quantity limit reached');
              }
              var liErr = row.querySelector('.li-inv-error');
              if (liErr) {
                liErr.textContent = warnMsg;
                liErr.hidden = false;
              }
            }
          }

          renderCartDOM(cart);
          updateCounts(cart.item_count, true);
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
          } catch (e) {}
        })
        .catch(function (err) {
          self.inFlight[k] = false;
          console.warn('[TDC Cart] update error:', err.message);

          if (self.pending[k] != null && self.pending[k] !== qtyToSend) {
            self.process(key, line, row);
            return;
          }

          delete self.pending[k];
          if (window.TDCToast && window.TDCToast.warning) {
            window.TDCToast.warning(err.message, 'Quantity limit reached');
          }
          if (row) {
            var liErr = row.querySelector('.li-inv-error');
            if (liErr) {
              liErr.textContent = err.message;
              liErr.hidden = false;
            }
          }
        });
    }
  };

  window.TDCCartQueue = TDCCartQueue;

  function updateQuantity(key, newQty, row, line) {
    if (newQty === 0) {
      removeItem(row, key, line);
      return;
    }
    TDCCartQueue.setTarget(key, line, newQty, row);
  }

  function initCartEvents() {
    var itemsEl = getDrawerItemsEl();
    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var row = e.target.closest('.line-item');
        if (!row || row.classList.contains('is-removing')) return;
        var key = row.getAttribute('data-key');
        var line = row.getAttribute('data-line') || (Array.prototype.indexOf.call(itemsEl.children, row) + 1);

        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          var out = row.querySelector('output');
          var currentQty = row._targetQty != null ? row._targetQty : (out ? parseInt(out.textContent, 10) : 1);
          var diff = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);

          // Inventory guard for + button
          if (diff > 0) {
            var itemId = row.getAttribute('data-id');
            var invPolicy = row.getAttribute('data-inv-policy') || '';
            var invInfo = window._variantInventory && (window._variantInventory[itemId]);
            if (invInfo && invInfo.policy) invPolicy = invInfo.policy;

            // If Shopify setting is "Continue selling when out of stock" ON, allow increasing qty!
            if (invPolicy !== 'continue') {
              var invLimit = parseInt(row.getAttribute('data-inv-qty'), 10);
              if (isNaN(invLimit) || invLimit < 0) {
                if (invInfo && invInfo.management && invInfo.policy !== 'continue' && invInfo.qty != null) {
                  invLimit = invInfo.qty;
                }
              }
              if (!isNaN(invLimit) && invLimit >= 0 && (currentQty + diff) > invLimit) {
                var itemTitle = row.querySelector('.li-name') ? row.querySelector('.li-name').textContent.trim() : 'this item';
                var metaEl = row.querySelector('.li-meta');
                if (metaEl && metaEl.textContent.trim()) {
                  itemTitle = metaEl.textContent.trim();
                }
                var msg = invLimit <= 0
                  ? itemTitle + ' is currently unavailable.'
                  : invLimit === 1
                  ? 'Only 1 ' + itemTitle + ' is available. You cannot add more.'
                  : 'Only ' + invLimit + ' ' + itemTitle + ' are available. You cannot add more.';
                if (window.TDCToast && window.TDCToast.warning) {
                  window.TDCToast.warning(msg, 'Quantity limit reached');
                }
                var liErr = row.querySelector('.li-inv-error');
                if (liErr) {
                  liErr.textContent = msg;
                  liErr.hidden = false;
                }
                // Visually shake the qty output
                if (out) {
                  out.classList.remove('qty-shake');
                  void out.offsetWidth;
                  out.classList.add('qty-shake');
                }
                return; // Block the increase
              }
            }
          }

          // Clear error when decreasing or removing
          if (diff < 0) {
            var liErr2 = row.querySelector('.li-inv-error');
            if (liErr2) {
              liErr2.hidden = true;
              liErr2.textContent = '';
            }
          }

          var nextQty = Math.max(0, currentQty + diff);
          row._targetQty = nextQty;

          if (out) {
            out.textContent = nextQty;
            out.classList.remove('qty-pop');
            void out.offsetWidth;
            out.classList.add('qty-pop');
          }

          if (nextQty === 0) {
            removeItem(row, key, line);
          } else {
            TDCCartQueue.setTarget(key, line, nextQty, row);
          }
          return;
        }

        if (e.target.closest('[data-remove-item]')) {
          e.preventDefault();
          clearTimeout(row._qtyTimer);
          row._targetQty = 0;
          removeItem(row, key, line);
        }
      });
    }

    // Attach Cart Page AJAX listeners
    var cartPage = document.querySelector('.cart-page');
    if (cartPage) {
      cartPage.addEventListener('click', function (e) {
        // Remove button click
        var removeBtn = e.target.closest('.text-btn, [aria-label^="Remove"]');
        if (removeBtn) {
          e.preventDefault();
          var row = removeBtn.closest('.line-item');
          if (!row) return;
          var key = row.getAttribute('data-key');
          if (key) {
            removeItem(row, key);
          }
          return;
        }

        // Quantity +/- button click
        var qtyBtn = e.target.closest('.qty button[name="quantity"]');
        if (qtyBtn) {
          e.preventDefault();
          var row = qtyBtn.closest('.line-item');
          if (!row || row.classList.contains('is-removing')) return;
          var key = row.getAttribute('data-key');
          var input = row.querySelector('.qty-input, input[name="quantity"]');
          var targetQty = parseInt(qtyBtn.getAttribute('value'), 10);
          if (isNaN(targetQty)) {
            var isPlus = qtyBtn.textContent.trim() === '+';
            var currentQty = parseInt(input ? input.value : '1', 10) || 1;
            targetQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);
          }
          
          // Inventory guard for cart page
          if (targetQty > 0) {
            var itemId = row.getAttribute('data-id');
            var invPolicy = row.getAttribute('data-inv-policy') || '';
            var invInfo = window._variantInventory && (window._variantInventory[itemId]);
            if (invInfo && invInfo.policy) invPolicy = invInfo.policy;

            // If Shopify setting is "Continue selling when out of stock" ON, allow increasing qty!
            if (invPolicy !== 'continue') {
              var invLimit = parseInt(row.getAttribute('data-inv-qty'), 10);
              if (isNaN(invLimit) || invLimit < 0) {
                if (invInfo && invInfo.management && invInfo.policy !== 'continue' && invInfo.qty != null) {
                  invLimit = invInfo.qty;
                }
              }
              if (!isNaN(invLimit) && invLimit >= 0 && targetQty > invLimit) {
                var itemTitle = row.querySelector('.li-name') ? row.querySelector('.li-name').textContent.trim() : 'this item';
                var metaEl = row.querySelector('.li-meta');
                if (metaEl && metaEl.textContent.trim()) {
                  itemTitle = metaEl.textContent.trim();
                }
                var msg = invLimit === 1
                  ? 'Only 1 ' + itemTitle + ' is available. You cannot add more.'
                  : 'Only ' + invLimit + ' ' + itemTitle + ' are available. You cannot add more.';
                if (window.TDCToast && window.TDCToast.warning) {
                  window.TDCToast.warning(msg, 'Quantity limit reached');
                }
                var liErr = row.querySelector('.li-inv-error');
                if (liErr) {
                  liErr.textContent = msg;
                  liErr.hidden = false;
                }
                // Reset input to current valid quantity
                if (input) {
                  var currentQty = parseInt(input.value, 10) || 1;
                  input.value = Math.min(currentQty, invLimit);
                }
                return;
              }
            }
          } else {
            var liErr3 = row.querySelector('.li-inv-error');
            if (liErr3) {
              liErr3.hidden = true;
              liErr3.textContent = '';
            }
          }
          
          row._targetQty = targetQty;
          if (input) input.value = targetQty;
          if (targetQty === 0) {
            removeItem(row, key);
          } else {
            TDCCartQueue.setTarget(key, null, targetQty, row);
          }
          return;
        }
      });

      // Direct input change
      cartPage.addEventListener('change', function (e) {
        var input = e.target.closest('.qty-input, input[name="quantity"]');
        if (!input) return;
        var row = input.closest('.line-item');
        if (!row || row.classList.contains('is-removing')) return;
        var key = row.getAttribute('data-key');
        var val = Math.max(0, parseInt(input.value, 10) || 0);
        
        // Inventory guard for direct input
        if (val > 0) {
          var itemId = row.getAttribute('data-id');
          var invLimit = parseInt(row.getAttribute('data-inv-qty'), 10);
          if (isNaN(invLimit) || invLimit < 0) {
            var invInfo = window._variantInventory && (window._variantInventory[itemId]);
            if (invInfo && invInfo.management && invInfo.policy !== 'continue' && invInfo.qty != null) {
              invLimit = invInfo.qty;
            }
          }
          if (!isNaN(invLimit) && invLimit >= 0 && val > invLimit) {
            var itemTitle = row.querySelector('.li-name') ? row.querySelector('.li-name').textContent.trim() : 'this item';
            var metaEl = row.querySelector('.li-meta');
            if (metaEl && metaEl.textContent.trim()) {
              itemTitle = metaEl.textContent.trim();
            }
            var msg = invLimit === 1
              ? 'Only 1 ' + itemTitle + ' is available. You cannot add more.'
              : 'Only ' + invLimit + ' ' + itemTitle + ' are available. You cannot add more.';
            if (window.TDCToast && window.TDCToast.warning) {
              window.TDCToast.warning(msg, 'Quantity limit reached');
            }
            var liErr = row.querySelector('.li-inv-error');
            if (liErr) {
              liErr.textContent = msg;
              liErr.hidden = false;
            }
            // Reset input to max allowed
            input.value = invLimit;
            val = invLimit;
          } else {
            var liErr4 = row.querySelector('.li-inv-error');
            if (liErr4) {
              liErr4.hidden = true;
              liErr4.textContent = '';
            }
          }
        }
        
        input.value = val;
        row._targetQty = val;
        if (val === 0) {
          removeItem(row, key);
        } else {
          TDCCartQueue.setTarget(key, null, val, row);
        }
      });

      // Prevent native form submission
      cartPage.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartEvents);
  } else {
    initCartEvents();
  }

  // Refresh cart only on bfcache navigation (back/forward button), not on fresh page loads
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      fetchCartAndRender();
    }
  });

  // "Pairs well with" Add button with loading & success state
  var drawerEl = getDrawer();
  if (drawerEl) {
    drawerEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-id]');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-upsell-id');
      if (!id) return;

      var origText = btn.textContent;
      btn.disabled = true;
      btn.classList.add('atc-loading');
      btn.textContent = 'Adding…';

      addToCart(id, 1, function () {
        btn.classList.remove('atc-loading');
        btn.classList.add('atc-success');
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.classList.remove('atc-success');
          btn.textContent = origText;
          btn.disabled = false;
        }, 1600);
      }, function () {
        btn.classList.remove('atc-loading');
        btn.disabled = false;
        btn.textContent = origText;
      });
    });
  }

  var giftToggle = document.getElementById('gift-toggle');
  var giftFields = document.getElementById('gift-fields');
  if (giftToggle && giftFields) {
    giftToggle.addEventListener('change', function () { giftFields.hidden = !giftToggle.checked; });
  }

  var giftNote = document.getElementById('gift-note');
  if (giftNote) {
    var noteTimer = null;
    giftNote.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: giftNote.value })
        }).catch(function () {});
      }, 500);
    });
  }

  // NOTE: Quick-add buttons on collection cards are handled solely by
  // initProductCards() below, which uses a data-initialized guard to prevent
  // duplicate listeners. The global document click handler has been removed to
  // avoid calling addToCart twice (which caused cart quantity to jump to 2).

  // Harvest server-rendered cart inventory if present in DOM
  try {
    document.querySelectorAll('#cart-items .line-item[data-id]').forEach(function (row) {
      var id = row.getAttribute('data-id');
      var q = parseInt(row.getAttribute('data-inv-qty'), 10);
      var m = row.getAttribute('data-inv-managed');
      var p = row.getAttribute('data-inv-policy');
      if (id && !isNaN(q) && q >= 0) {
        window._variantInventory = window._variantInventory || {};
        window._variantInventory[id] = window._variantInventory[id] || {
          qty: q,
          management: m || 'shopify',
          policy: p || 'deny'
        };
      }
    });
  } catch (e) {}

  window.TDCCart = window.TDCCart || {};
  Object.assign(window.TDCCart, {
    add: addToCart,
    fetch: fetchCartAndRender,
    updateQuantity: updateQuantity,
    removeItem: removeItem,
    render: renderCartDOM,
    renderCartPage: renderCartPageDOM
  });

  function syncCardButtonLimits(passedCart) {
    var cart = passedCart || (window.TDCCart && window.TDCCart.currentCart) || window._themeCart;
    var items = (cart && cart.items) || [];
    document.querySelectorAll('.card[data-variant-id]').forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      var btn = card.querySelector('.quick:not(.notify-me)');
      if (!btn) return;
      if (!btn.getAttribute('data-original-text')) {
        btn.setAttribute('data-original-text', btn.textContent.trim());
      }
      var origText = btn.getAttribute('data-original-text') || 'Add to bag';

      var rawInvQty = parseInt(card.getAttribute('data-inv-qty'), 10);
      var invManaged = card.getAttribute('data-inv-managed') || '';
      var invPolicy = card.getAttribute('data-inv-policy') || '';

      var lowBadge = card.querySelector('.badge-low-stock');
      if (lowBadge) {
        var badgeMatch = lowBadge.textContent.match(/(\d+)/);
        if (badgeMatch) {
          var badgeQty = parseInt(badgeMatch[1], 10);
          if (!isNaN(badgeQty)) {
            rawInvQty = badgeQty;
            if (!invManaged) invManaged = 'shopify';
            if (!invPolicy) invPolicy = 'deny';
          }
        }
      }

      var invInfo = window._variantInventory && window._variantInventory[variantId];
      if (invInfo && invInfo.management) {
        invManaged = invInfo.management;
        invPolicy = invInfo.policy || invPolicy;
        if (invInfo.qty != null) rawInvQty = parseInt(invInfo.qty, 10);
      }

      var hasLimit = !!(invManaged && invPolicy !== 'continue' && !isNaN(rawInvQty) && rawInvQty >= 0);
      if (!hasLimit) {
        if (btn.classList.contains('atc-limit')) {
          btn.classList.remove('atc-limit');
          btn.disabled = false;
          btn.textContent = origText;
        }
        return;
      }

      var cartQty = 0;
      var cartItem = items.find(function (i) {
        return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId);
      });
      if (cartItem) cartQty = parseInt(cartItem.quantity, 10) || 0;

      var effectiveQty = window.TDCCartGuard
        ? window.TDCCartGuard.getEffectiveCartQty(variantId)
        : Math.max(cartQty, 0);

      // 'In bag' should ONLY appear if the product is actually in the cart AND its quantity reaches or exceeds inventory limit
      if (effectiveQty > 0 && effectiveQty >= rawInvQty) {
        btn.classList.add('atc-limit');
        btn.disabled = true;
        btn.textContent = 'In bag';
      } else {
        if (btn.classList.contains('atc-limit')) {
          btn.classList.remove('atc-limit');
          btn.disabled = false;
          btn.textContent = origText;
        }
      }
    });
  }

  function initProductCards(container) {
    var cRoot = container || document;
    var quickBtns = cRoot.querySelectorAll('.card .quick:not(.notify-me):not([data-initialized])');
    quickBtns.forEach(function (btn) {
      btn.setAttribute('data-initialized', 'true');
      btn.setAttribute('data-original-text', btn.textContent);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.card');
        if (!card) return;
        var variantId = card.getAttribute('data-variant-id');
        if (!variantId) return;

        // ── Inventory limit detection ─────────────────────────────────────────
        var rawInvQty    = parseInt(card.getAttribute('data-inv-qty'), 10);
        var invManaged   = card.getAttribute('data-inv-managed') || '';
        var invPolicy    = card.getAttribute('data-inv-policy')  || '';

        // "Only X left" badge is the most reliable fallback
        var lowBadge = card.querySelector('.badge-low-stock');
        if (lowBadge) {
          var badgeMatch = lowBadge.textContent.match(/(\d+)/);
          if (badgeMatch) {
            var badgeQty = parseInt(badgeMatch[1], 10);
            if (!isNaN(badgeQty)) {
              rawInvQty = badgeQty;
              if (!invManaged) invManaged = 'shopify';
              if (!invPolicy) invPolicy = 'deny';
            }
          }
        }

        // Fresher data from window._variantInventory takes priority
        var invInfo = window._variantInventory && window._variantInventory[variantId];
        if (invInfo && invInfo.management) {
          invManaged = invInfo.management;
          invPolicy  = invInfo.policy  || invPolicy;
          if (invInfo.qty != null) rawInvQty = parseInt(invInfo.qty, 10);
        }

        var hasLimit = !!(invManaged && invPolicy !== 'continue' && !isNaN(rawInvQty) && rawInvQty >= 0);
        var invLimit = hasLimit ? rawInvQty : Infinity;

        // ── Optimistic stock guard (TDCCartGuard) ────────────────────────────
        // This catches rapid clicks BEFORE the AJAX response arrives, because
        // TDCCartGuard tracks in-flight (pending) quantities as well as
        // confirmed (cart) quantities.
        var productTitle = card.querySelector('h3 a') ? card.querySelector('h3 a').textContent.trim() : 'this item';

        if (hasLimit) {
          var canAdd = window.TDCCartGuard
            ? window.TDCCartGuard.canAdd(variantId, 1, invLimit)
            : true; // fallback: allow if guard not loaded

          if (!canAdd) {
            var effectiveQty = window.TDCCartGuard ? window.TDCCartGuard.getEffectiveCartQty(variantId) : 0;
            var errMsg = invLimit <= 0
              ? productTitle + ' is currently unavailable.'
              : invLimit === 1
                ? 'Only 1 ' + productTitle + ' is available. You already have it in your bag.'
                : 'Only ' + invLimit + ' ' + productTitle + ' are available. You already have ' + effectiveQty + ' in your bag.';
            if (window.TDCToast && window.TDCToast.warning) {
              window.TDCToast.warning(errMsg, 'Quantity limit reached');
            }
            btn.classList.add('qty-shake');
            setTimeout(function () { btn.classList.remove('qty-shake'); }, 600);
            return;
          }
        }

        // Legacy fallback check using confirmed cart qty only (for when TDCCartGuard is absent)
        if (!window.TDCCartGuard && hasLimit) {
          var cartQty = 0;
          var currentCart = (window.TDCCart && window.TDCCart.currentCart) || window._themeCart;
          if (currentCart && currentCart.items) {
            var existing = currentCart.items.find(function (i) {
              return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId);
            });
            if (existing) cartQty = parseInt(existing.quantity, 10) || 0;
          }
          if (cartQty === 0) {
            var drawerRow = document.querySelector('#cart-items .line-item[data-id="' + variantId + '"]');
            if (drawerRow) {
              var rowOut = drawerRow.querySelector('output');
              if (rowOut) cartQty = parseInt(rowOut.textContent, 10) || 0;
            }
          }
          if ((cartQty + 1) > invLimit) {
            var errMsg2 = invLimit <= 0
              ? productTitle + ' is currently unavailable.'
              : invLimit === 1
                ? 'Only 1 ' + productTitle + ' is available. You already have it in your bag.'
                : 'Only ' + invLimit + ' ' + productTitle + ' are available. You already have ' + cartQty + ' in your bag.';
            if (window.TDCToast && window.TDCToast.warning) {
              window.TDCToast.warning(errMsg2, 'Quantity limit reached');
            }
            btn.classList.add('qty-shake');
            setTimeout(function () { btn.classList.remove('qty-shake'); }, 600);
            return;
          }
        }
        // ── End stock guard ──────────────────────────────────────────────────

        // Reserve 1 unit optimistically BEFORE the AJAX call
        if (window.TDCCartGuard) window.TDCCartGuard.reserve(variantId, 1);

        btn.classList.add('atc-loading');
        btn.disabled = true;

        addToCart(variantId, 1, function () {
          // addToCart calls TDCCartGuard.confirm internally via fetchCartAndRender
          btn.classList.remove('atc-loading');
          btn.classList.add('atc-success');
          btn.textContent = 'Added ✓';

          // Check post-add limit from updated cart
          var newCart = window.TDCCart && window.TDCCart.currentCart;
          var newCartQty = window.TDCCartGuard
            ? window.TDCCartGuard.getEffectiveCartQty(variantId)
            : 1;
          if (newCart && newCart.items) {
            var addedItem = newCart.items.find(function (i) {
              return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId);
            });
            if (addedItem) newCartQty = addedItem.quantity || newCartQty;
          }

          var nowAtLimit = hasLimit && newCartQty >= invLimit;
          setTimeout(function () {
            btn.classList.remove('atc-success');
            if (nowAtLimit) {
              btn.textContent = 'In bag';
              btn.disabled = true;
              btn.classList.add('atc-limit');
            } else {
              btn.textContent = btn.getAttribute('data-original-text') || 'Add to bag';
              btn.disabled = false;
            }
          }, 1600);
        }, function (err) {
          // addToCart calls TDCCartGuard.release internally on error
          btn.classList.remove('atc-loading');
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-original-text') || 'Add to bag';
          var apiMsg = (err && err.message) ? err.message : ('Could not add ' + productTitle + ' — quantity limit reached.');
          if (window.TDCToast && window.TDCToast.warning) {
            window.TDCToast.warning(apiMsg, 'Quantity limit reached');
          }
          btn.classList.add('qty-shake');
          setTimeout(function () { btn.classList.remove('qty-shake'); }, 600);
        });
      });
    });
    syncCardButtonLimits();
  }

  function flattenExpressCheckout() {
    document.querySelectorAll('.express').forEach(function (express) {
      var wallets = express.querySelectorAll('.dynamic-checkout-cart');
      if (!wallets.length) return;
      wallets.forEach(function (el) {
        express.appendChild(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flattenExpressCheckout);
  } else {
    flattenExpressCheckout();
  }
  setTimeout(flattenExpressCheckout, 600);
  setTimeout(flattenExpressCheckout, 1600);

  window.TDC = window.TDC || {};
  window.TDC.initProductCards = initProductCards;
  window.TDC.syncCardButtonLimits = syncCardButtonLimits;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProductCards(); });
  } else {
    initProductCards();
  }

  // ── Re-sync card buttons whenever cart changes ──
  // This ensures "In Bag" / "Add to Bag" state is always correct after
  // any cart add, remove, or quantity change — including from cart drawer.
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    syncCardButtonLimits(cart || null);
  });
})();
